import { CreditCard, Tag, Wallet } from 'lucide-react';

import type { SaleOrderCertificateType } from '@/types/api/mutations';
import type {
  ClientCertificateItemKind,
  ClientCertificateStatus,
} from '@/types/api/queries';
import type { LucideIcon } from 'lucide-react';

export const CERTIFICATE_SELLABLE_TYPE: SaleOrderCertificateType =
  'Catalog::ClientCertificate';

export const CERTIFICATE_STATUS_LABEL_KEYS = {
  draft: 'certificate_status_draft',
  active: 'certificate_status_active',
  fully_redeemed: 'certificate_status_fully_redeemed',
  expired: 'certificate_status_expired',
  refunded: 'certificate_status_refunded',
} satisfies Record<ClientCertificateStatus, string>;

export const CERTIFICATE_KIND_ICONS = {
  service: Tag,
  card: CreditCard,
  deposit: Wallet,
} satisfies Record<ClientCertificateItemKind, LucideIcon>;
